export default __webpack_public_path__ + "static/media/photo5.c70f64b7.jpg";